import { registerNew } from '@actions/auth';
import AuthLangSwitch from '@components/AuthLangSwitch';
import { needsNoAuth } from '@components/utils/authHoc';
import { yupResolver } from '@hookform/resolvers/yup';
import Form from '@ui/Form';
import { Tabs } from 'antd';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { compose } from 'redux';
import { useRedux } from 'use-redux';
import { ENTITIES, DEFAULT_REGISTRATION_AGE } from './constants';
import { FormData } from './interfaces';
import { getSchema } from './schema';
import { StudentForm, AdultForm } from './forms';
import styles from './styles.module.scss';
import { Link } from 'react-router';
import { I18n } from 'react-redux-i18n';
import { getTimeZone } from '@utils/date';

import '../../../styles/auth-page.scss';

const { TabPane } = Tabs;

const Registration = props => {
  const [{ i18n }, dispatch] = useRedux();
  const {
    params: { invite },
  } = props;

  const [activeEntity, setActiveEntity] = useState(ENTITIES.student);

  const formMethods = useForm<FormData>({
    resolver: yupResolver(getSchema(activeEntity)),
    mode: 'onChange',
    defaultValues: {
      age: DEFAULT_REGISTRATION_AGE,
    },
  });

  const { reset } = formMethods;

  const handleChangeEntity = newActiveEntity => {
    setActiveEntity(newActiveEntity);
    reset({ age: DEFAULT_REGISTRATION_AGE });
  };

  const handleFormSubmit = async (values: FormData) => {
    dispatch(
      registerNew({
        entity: activeEntity,
        language: i18n.locale,
        timezone: getTimeZone(),
        invite,
        ...values,
        age: values.age != null ? values.age : DEFAULT_REGISTRATION_AGE,
      })
    );
  };

  return (
    <div className="rts-auth">
      <div className={`rts-auth__card ${styles.card}`}>
        <img
          className="rts-auth__logo"
          src="/rts-logo-v3.7207c58d.png"
          alt="Rocket Tech School"
        />

        <h1 className={styles.title}>{I18n.t('register.signup')}</h1>

        <Form
          formMethods={formMethods}
          onSubmit={handleFormSubmit}
          className={styles.form}
        >
          <Tabs
            type="card"
            centered
            defaultActiveKey={ENTITIES.student}
            activeKey={activeEntity}
            onChange={handleChangeEntity}
            className={`${styles.tabs} ${styles.tabsStudentOnly}`}
            destroyInactiveTabPane={true}
          >
            <TabPane tab={I18n.t('register.student')} key={ENTITIES.student}>
              <StudentForm />
            </TabPane>

            <TabPane
              tab={I18n.t('register.parent')}
              key={ENTITIES.parent}
              className={styles.hiddenRegisterEntity}
            >
              <AdultForm />
            </TabPane>

            <TabPane
              tab={I18n.t('register.teacher')}
              key={ENTITIES.teacher}
              className={styles.hiddenRegisterEntity}
            >
              <AdultForm />
            </TabPane>
          </Tabs>

          <label className={styles.agreeItem}>
            <input type="checkbox" name="agree" required />
            <span>{I18n.t('register.smsAgree')}</span>
          </label>
        </Form>

        <div className={styles.footer}>
          <a
            className={styles.policyLink}
            href="https://www.rts.school/agreement/ru"
            target="_blank"
            rel="noopener noreferrer"
          >
            {I18n.t('register.privacyPolicy')}
          </a>

          <div className={styles.loginBlock}>
            <p className={styles.loginText}>
              {I18n.t('register.hasAccountQuestion')}
            </p>
            <Link to="/i/auth" className={styles.loginButton}>
              {I18n.t('auth.login')}
            </Link>
          </div>
        </div>
      </div>

      <AuthLangSwitch />
    </div>
  );
};

export default compose(needsNoAuth)(Registration);
